<template>
    <div class="svg-en-construccion">
        <svg id="OBJECTS" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 378 238.7">
            <g>
                <path class="st8"
                    d="M77.7,6.4h222.3c6.5,0,11.8,5.3,11.8,11.8v134.8c0,6.9-5.6,12.5-12.5,12.5H78.4c-6.9,0-12.5-5.6-12.5-12.5V18.2c0-6.5,5.3-11.8,11.8-11.8Z" />
                <rect class="st5" x="77.4" y="17.2" width="223" height="125.4" />
                <path class="st4"
                    d="M65.9,142.6h245.9v14.5c0,6.5-5.3,11.8-11.8,11.8H77.7c-6.5,0-11.8-5.3-11.8-11.8v-14.5h0Z" />
                <polygon class="st7" points="206.5 168.8 171.2 168.8 164.6 203.4 213 203.4 206.5 168.8" />
                <rect class="st6" x="153.8" y="203.4" width="70.2" height="9.3" />
                <path class="st5" d="M195.6,155.7c0,3.8-3,6.8-6.8,6.8s-6.8-3-6.8-6.8,3-6.8,6.8-6.8,6.8,3,6.8,6.8Z" />
                <rect class="st3" x="95.7" y="33.6" width="49.8" height="91.7" />
                <rect class="st3" x="154.1" y="77.3" width="55.9" height="48.1" />
                <rect class="st3" x="223.9" y="33.6" width="55.9" height="40.1" />
                <rect class="st3" x="223.9" y="113.3" width="55.9" height="5" />
                <rect class="st3" x="223.9" y="105.6" width="55.9" height="5" />
                <rect class="st3" x="223.9" y="98" width="55.9" height="5" />
                <rect class="st3" x="223.9" y="90.3" width="55.9" height="5" />
                <rect class="st3" x="223.9" y="82.6" width="55.9" height="5" />
                <rect class="st3" x="154.1" y="66.5" width="55.9" height="5" />
                <rect class="st3" x="154.1" y="58.8" width="55.9" height="5" />
                <rect class="st3" x="154.1" y="51.2" width="55.9" height="5" />
                <rect class="st3" x="154.1" y="43.5" width="55.9" height="5" />
                <rect class="st3" x="154.1" y="35.8" width="55.9" height="5" />
            </g>
            <g>
                <polygon class="st10" points="245.8 220.1 231.8 220.1 247.7 92.8 261.7 92.8 245.8 220.1" />
                <polygon class="st10" points="354.8 220.1 368.8 220.1 353 92.8 338.9 92.8 354.8 220.1" />
                <rect class="st9" x="235.6" y="53.7" width="129.5" height="58.8" />
                <rect class="st0" x="235.6" y="84.1" width="129.5" height="28.4" />
                <g>
                    <rect class="st2" x="228.9" y="136" width="142.9" height="15.8" />
                    <g>
                        <polygon class="st10" points="245.4 136 239.1 151.8 230.2 151.8 236.5 136 245.4 136" />
                        <polygon class="st10" points="261 136 254.7 151.8 245.7 151.8 252 136 261 136" />
                        <polygon class="st10" points="276.6 136 270.3 151.8 261.3 151.8 267.6 136 276.6 136" />
                        <polygon class="st10" points="292.2 136 285.9 151.8 276.9 151.8 283.2 136 292.2 136" />
                        <polygon class="st10" points="307.7 136 301.4 151.8 292.5 151.8 298.8 136 307.7 136" />
                        <polygon class="st10" points="323.3 136 317 151.8 308.1 151.8 314.3 136 323.3 136" />
                        <polygon class="st10" points="338.9 136 332.6 151.8 323.6 151.8 329.9 136 338.9 136" />
                        <polygon class="st10" points="354.5 136 348.2 151.8 339.2 151.8 345.5 136 354.5 136" />
                        <polygon class="st10" points="370 136 363.8 151.8 354.8 151.8 361.1 136 370 136" />
                    </g>
                </g>
                <g>
                    <rect class="st2" x="228.9" y="176" width="142.9" height="15.8" />
                    <g>
                        <polygon class="st10" points="245.4 176 239.1 191.8 230.2 191.8 236.5 176 245.4 176" />
                        <polygon class="st10" points="261 176 254.7 191.8 245.7 191.8 252 176 261 176" />
                        <polygon class="st10" points="276.6 176 270.3 191.8 261.3 191.8 267.6 176 276.6 176" />
                        <polygon class="st10" points="292.2 176 285.9 191.8 276.9 191.8 283.2 176 292.2 176" />
                        <polygon class="st10" points="307.7 176 301.4 191.8 292.5 191.8 298.8 176 307.7 176" />
                        <polygon class="st10" points="323.3 176 317 191.8 308.1 191.8 314.3 176 323.3 176" />
                        <polygon class="st10" points="338.9 176 332.6 191.8 323.6 191.8 329.9 176 338.9 176" />
                        <polygon class="st10" points="354.5 176 348.2 191.8 339.2 191.8 345.5 176 354.5 176" />
                        <polygon class="st10" points="370 176 363.8 191.8 354.8 191.8 361.1 176 370 176" />
                    </g>
                </g>
                <g>
                    <g>
                        <path class="st10"
                            d="M246.3,60.8c0,1.5-1.2,2.7-2.7,2.7s-2.7-1.2-2.7-2.7,1.2-2.7,2.7-2.7,2.7,1.2,2.7,2.7Z" />
                        <path class="st10"
                            d="M246.3,105.3c0,1.5-1.2,2.7-2.7,2.7s-2.7-1.2-2.7-2.7,1.2-2.7,2.7-2.7,2.7,1.2,2.7,2.7Z" />
                    </g>
                    <g>
                        <path class="st10"
                            d="M359.3,60.8c0,1.5-1.2,2.7-2.7,2.7s-2.7-1.2-2.7-2.7,1.2-2.7,2.7-2.7,2.7,1.2,2.7,2.7Z" />
                        <path class="st10"
                            d="M359.3,105.3c0,1.5-1.2,2.7-2.7,2.7s-2.7-1.2-2.7-2.7,1.2-2.7,2.7-2.7,2.7,1.2,2.7,2.7Z" />
                    </g>
                </g>
            </g>
            <g>
                <rect class="st0" x="5.6" y="210.6" width="95.6" height="11.7" />
                <polygon class="st9"
                    points="90.3 210.6 16.5 210.6 18 206.5 22.1 194.9 27 181.1 32.2 166.6 37.2 152.8 42.4 138.3 47.3 124.5 52.9 108.8 53.9 108.8 59.5 124.5 64.4 138.3 69.6 152.8 74.5 166.6 79.7 181.1 84.7 194.9 88.8 206.5 90.3 210.6" />
                <g>
                    <polygon class="st1" points="64.4 138.3 42.4 138.3 47.3 124.5 59.5 124.5 64.4 138.3" />
                    <polygon class="st1" points="74.5 166.6 32.2 166.6 37.2 152.8 69.6 152.8 74.5 166.6" />
                    <polygon class="st1" points="84.7 194.9 22.1 194.9 27 181.1 79.7 181.1 84.7 194.9" />
                </g>
            </g>
        </svg>
        <p>Sección en construcción.</p>
    </div>
</template>

<style scoped lang="scss">
.svg-en-construccion {
    text-align: center;
    padding: 16px 0;
}

.svg-en-construccion p {
    font-size: 1.175rem;
}

.svg-en-construccion svg {
    width: 240px;
    margin-bottom: 8px
}

.st0 {
    fill: $base-accent;
}

.st1 {
    fill: #fff7f5;
}

.st2 {
    fill: #fdb827;
}

.st3 {
    fill: $base-accent;
}

.st4 {
    fill: #7c8b96;
}

.st5 {
    fill: #f5f5f5;
}

.st6 {
    fill: #a6b3bd;
}

.st7 {
    fill: #cad6dd;
}

.st8 {
    fill: #d8e2e7;
}

.st9 {
    fill: lighten($base-accent, 20%);
}

.st10 {
    fill: darken($base-accent, 10%);
}
</style>